import * as React from 'react';

import { useResponsiveBreakpoints } from '@src/hooks/useMediaQuery';

interface PopularSearchesProps {
  title?: string;
  searches?: any[];
  className?: string;
  onSearchClick?: (search: any) => void;
}

export const PopularSearches: React.FC<PopularSearchesProps> = ({
  title = 'Popular searches',
  searches = [],
  className = '',
  onSearchClick
}) => {
  const { isMobile } = useResponsiveBreakpoints();

  if (!searches || searches.length === 0) return <div></div>;

  return (
    <div className={`flex max-lg:flex-col gap-4 lg:items-center ${className}`}>
      <p className={`${isMobile ? 'b7--bold' : 'b6--bold'}`}>{title}</p>
      <div className='flex flex-wrap gap-x-3 gap-y-3 lg:gap-x-6 items-center'>
        {searches.map((search: any, index: number) => (
          <button
            key={index}
            onClick={() => onSearchClick?.(search)}
            className={`underline lg:no-underline hover:underline ${isMobile ? 'b8--medium' : 'b7--medium'}`}
          >
            {search.title}
          </button>
        ))}
      </div>
    </div>
  );
};
